/*
 * @Author: Nora Galvin
 * @Date: 2020-08-26 16:32:14
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-28 15:18:19
 */
export default {
  gf__bounce: {
    '-webkit-animation-name': 'gf_bounce',
    'animation-name': 'gf_bounce',
    '-webkit-transform-origin': 'center bottom',
    'transform-origin': 'center bottom',
  },
  gf__flash: {
    '-webkit-animation-name': 'gf_flash',
    'animation-name': 'gf_flash',
  },
  gf__pulse: {
    '-webkit-animation-name': 'gf_pulse',
    'animation-name': 'gf_pulse',
    '-webkit-animation-timing-function': 'ease-in-out',
    'animation-timing-function': 'ease-in-out',
  },
  gf__rubberBand: {
    '-webkit-animation-name': 'gf_rubberBand',
    'animation-name': 'gf_rubberBand',
  },
  gf__shakeX: {
    '-webkit-animation-name': 'gf_shakeX',
    'animation-name': 'gf_shakeX',
  },
  gf__shakeY: {
    '-webkit-animation-name': 'gf_shakeY',
    'animation-name': 'gf_shakeY',
  },
  gf__swing: {
    '-webkit-transform-origin': 'top center',
    'transform-origin': 'top center',
    '-webkit-animation-name': 'gf_swing',
    'animation-name': 'gf_swing',
  },
  gf__jello: {
    '-webkit-animation-name': 'gf_jello',
    'animation-name': 'gf_jello',
    '-webkit-transform-origin': 'center',
    'transform-origin': 'center',
  },
  gf__heartbeat: {
    '-webkit-animation-name': 'gf_heartbeat',
    'animation-name': 'gf_heartbeat',
    '-webkit-animation-duration': 'calc(1s * 1.3)',
    'animation-duration': 'calc(1s * 1.3)',
    '-webkit-animation-timing-function': 'ease-in-out',
    'animation-timing-function': 'ease-in-out',
  },
  gf__backInDown: {
    '-webkit-animation-name': 'gf_backInDown',
    'animation-name': 'gf_backInDown',
  },
  gf__backInLeft: {
    '-webkit-animation-name': 'gf_backInLeft',
    'animation-name': 'gf_backInLeft',
  },
  gf__backInRight: {
    '-webkit-animation-name': 'gf_backInRight',
    'animation-name': 'gf_backInRight',
  },
  gf__backInUp: {
    '-webkit-animation-name': 'gf_backInUp',
    'animation-name': 'gf_backInUp',
  },
  gf__backOutDown: {
    '-webkit-animation-name': 'gf_backOutDown',
    'animation-name': 'gf_backOutDown',
  },
  gf__backOutLeft: {
    '-webkit-animation-name': 'gf_backOutLeft',
    'animation-name': 'gf_backOutLeft',
  },
  gf__backOutRight: {
    '-webkit-animation-name': 'gf_backOutRight',
    'animation-name': 'gf_backOutRight',
  },
  gf__backOutUp: {
    '-webkit-animation-name': 'gf_backOutUp',
    'animation-name': 'gf_backOutUp',
  },
  gf__bounceIn: {
    '-webkit-animation-duration': 'calc(1s * 0.75)',
    'animation-duration': 'calc(1s * 0.75)',
    '-webkit-animation-name': 'gf_bounceIn',
    'animation-name': 'gf_bounceIn',
  },
  gf__bounceInDown: {
    '-webkit-animation-name': 'gf_bounceInDown',
    'animation-name': 'gf_bounceInDown',
  },
  gf__bounceInLeft: {
    '-webkit-animation-name': 'gf_bounceInLeft',
    'animation-name': 'gf_bounceInLeft',
  },
  gf__bounceInRight: {
    '-webkit-animation-name': 'gf_bounceInRight',
    'animation-name': 'gf_bounceInRight',
  },
  gf__bounceInUp: {
    '-webkit-animation-name': 'gf_bounceInUp',
    'animation-name': 'gf_bounceInUp',
  },
  gf__bounceOut: {
    '-webkit-animation-duration': 'calc(1s * 0.75)',
    'animation-duration': 'calc(1s * 0.75)',
    '-webkit-animation-name': 'gf_bounceOut',
    'animation-name': 'gf_bounceOut',
  },
  gf__bounceOutDown: {
    '-webkit-animation-name': 'gf_bounceOutDown',
    'animation-name': 'gf_bounceOutDown',
  },
  gf__bounceOutLeft: {
    '-webkit-animation-name': 'gf_bounceOutLeft',
    'a,nimation-name': 'gf_bounceOutLeft',
  },
  gf__bounceOutRight: {
    '-webkit-animation-name': 'gf_bounceOutRight',
    'animation-name': 'gf_bounceOutRight',
  },
  gf__bounceOutUp: {
    '-webkit-animation-name': 'gf_bounceOutUp',
    'animation-name': 'gf_bounceOutUp',
  },
  gf__fadeIn: {
    '-webkit-animation-name': 'gf_fadeIn',
    'animation-name': 'gf_fadeIn',
  },
  gf__fadeInDown: {
    '-webkit-animation-name': 'gf_fadeInDown',
    'animation-name': 'gf_fadeInDown',
  },
  gf__fadeInDownBig: {
    '-webkit-animation-name': 'gf_fadeInDownBig',
    'animation-name': 'gf_fadeInDownBig',
  },
  gf__fadeInLeft: {
    '-webkit-animation-name': 'gf_fadeInLeft',
    'animation-name': 'gf_fadeInLeft',
  },
  gf__fadeInLeftBig: {
    '-webkit-animation-name': 'gf_fadeInLeftBig',
    'animation-name': 'gf_fadeInLeftBig',
  },
  gf__fadeInRight: {
    '-webkit-animation-name': 'gf_fadeInRight',
    'animation-name': 'gf_fadeInRight',
  },
  gf__fadeInRightBig: {
    '-webkit-animation-name': 'gf_fadeInRightBig',
    'animation-name': 'gf_fadeInRightBig',
  },
  gf__fadeInUp: {
    '-webkit-animation-name': 'gf_fadeInUp',
    'animation-name': 'gf_fadeInUp',
  },
  gf__fadeInUpBig: {
    '-webkit-animation-name': 'gf_fadeInUpBig',
    'animation-name': 'gf_fadeInUpBig',
  },
  gf__fadeInTopLeft: {
    '-webkit-animation-name': 'gf_fadeInTopLeft',
    'animation-name': 'gf_fadeInTopLeft',
  },
  gf__fadeInTopRight: {
    '-webkit-animation-name': 'gf_fadeInTopRight',
    'animation-name': 'gf_fadeInTopRight',
  },
  gf__fadeInBottomLeft: {
    '-webkit-animation-name': 'gf_fadeInBottomLeft',
    'animation-name': 'gf_fadeInBottomLeft',
  },
  gf__fadeInBottomRight: {
    '-webkit-animation-name': 'gf_fadeInBottomRight',
    'animation-name': 'gf_fadeInBottomRight',
  },
  gf__fadeOut: {
    '-webkit-animation-name': 'gf_fadeOut',
    'animation-name': 'gf_fadeOut',
  },
  gf__fadeOutDown: {
    '-webkit-animation-name': 'gf_fadeOutDown',
    'animation-name': 'gf_fadeOutDown',
  },
  gf__fadeOutDownBig: {
    '-webkit-animation-name': 'gf_fadeOutDownBig',
    'animation-name': 'gf_fadeOutDownBig',
  },
  gf__fadeOutLeft: {
    '-webkit-animation-name': 'gf_fadeOutLeft',
    'animation-name': 'gf_fadeOutLeft',
  },
  gf__fadeOutLeftBig: {
    '-webkit-animation-name': 'gf_fadeOutLeftBig',
    'animation-name': 'gf_fadeOutLeftBig',
  },
  gf__fadeOutRight: {
    '-webkit-animation-name': 'gf_fadeOutRight',
    'animation-name': 'gf_fadeOutRight',
  },
  gf__fadeOutRightBig: {
    '-webkit-animation-name': 'gf_fadeOutRightBig',
    'animation-name': 'gf_fadeOutRightBig',
  },
  gf__fadeOutUp: {
    '-webkit-animation-name': 'gf_fadeOutUp',
    'animation-name': 'gf_fadeOutUp',
  },
  gf__fadeOutUpBig: {
    '-webkit-animation-name': 'gf_fadeOutUpBig',
    'animation-name': 'gf_fadeOutUpBig',
  },
  gf__fadeOutTopLeft: {
    '-webkit-animation-name': 'gf_fadeOutTopLeft',
    'animation-name': 'gf_fadeOutTopLeft',
  },
  gf__fadeOutTopRight: {
    '-webkit-animation-name': 'gf_fadeOutTopRight',
    'animation-name': 'gf_fadeOutTopRight',
  },
  gf__fadeOutBottomRight: {
    '-webkit-animation-name': 'gf_fadeOutBottomRight',
    'animation-name': 'gf_fadeOutBottomRight',
  },
  gf__fadeOutBottomLeft: {
    '-webkit-animation-name': 'gf_fadeOutBottomLeft',
    'animation-name': 'gf_fadeOutBottomLeft',
  },
  gf__flip: {
    '-webkit-backface-visibility': 'visible',
    'backface-visibility': 'visible',
    '-webkit-animation-name': 'gf_flip',
    'animation-name': 'gf_flip',
  },
  gf__flipInX: {
    '-webkit-backface-visibility': 'visible !important',
    'backface-visibility': 'visible !important',
    '-webkit-animation-name': 'gf_flipInX',
    'animation-name': 'gf_flipInX',
  },
  gf__flipInY: {
    '-webkit-backface-visibility': 'visible !important',
    'backface-visibility': 'visible !important',
    '-webkit-animation-name': 'gf_flipInY',
    'animation-name': 'gf_flipInY',
  },
  gf__flipOutX: {
    '-webkit-animation-duration': 'calc(1s * 0.75)',
    'animation-duration': 'calc(1s * 0.75)',
    '-webkit-animation-name': 'gf_flipOutX',
    'animation-name': 'gf_flipOutX',
    '-webkit-backface-visibility': 'visible !important',
    'backface-visibility': 'visible !important',
  },
  gf__flipOutY: {
    '-webkit-animation-duration': 'calc(1s * 0.75)',
    'animation-duration': 'calc(1s * 0.75)',
    '-webkit-backface-visibility': 'visible !important',
    'backface-visibility': 'visible !important',
    '-webkit-animation-name': 'gf_flipOutY',
    'animation-name': 'gf_flipOutY',
  },
  gf__jackInTheBox: {
    '-webkit-animation-name': 'gf_jackInTheBox',
    'animation-name': 'gf_jackInTheBox',
  },
  gf__zoomIn: {
    '-webkit-animation-name': 'gf_zoomIn',
    'animation-name': 'gf_zoomIn',
  },
  gf__zoomInDown: {
    '-webkit-animation-name': 'gf_zoomInDown',
    'animation-name': 'gf_zoomInDown',
  },
  gf__zoomInLeft: {
    '-webkit-animation-name': 'gf_zoomInLeft',
    'animation-name': 'gf_zoomInLeft',
  },
  gf__zoomInRight: {
    '-webkit-animation-name': 'gf_zoomInRight',
    'animation-name': 'gf_zoomInRight',
  },
  gf__zoomInUp: {
    '-webkit-animation-name': 'gf_zoomInUp',
    'animation-name': 'gf_zoomInUp',
  },
  gf__zoomOut: {
    '-webkit-animation-name': 'gf_zoomOut',
    'animation-name': 'gf_zoomOut',
  },
  gf__zoomOutDown: {
    '-webkit-animation-name': 'gf_zoomOutDown',
    'animation-name': 'gf_zoomOutDown',
    '-webkit-transform-origin': 'center bottom',
    'transform-origin': 'center bottom',
  },
  gf__zoomOutLeft: {
    '-webkit-animation-name': 'gf_zoomOutLeft',
    'animation-name': 'gf_zoomOutLeft',
    '-webkit-transform-origin': 'left center',
    'transform-origin': 'left center',
  },
  gf__zoomOutRight: {
    '-webkit-animation-name': 'gf_zoomOutRight',
    'animation-name': 'gf_zoomOutRight',
    '-webkit-transform-origin': 'right center',
    'transform-origin': 'right center',
  },
  gf__zoomOutUp: {
    '-webkit-animation-name': 'gf_zoomOutUp',
    'animation-name': 'gf_zoomOutUp',
    '-webkit-transform-origin': 'center bottom',
    'transform-origin': 'center bottom',
  },
  gf__slideInDown: {
    '-webkit-animation-name': 'gf_slideInDown',
    'animation-name': 'gf_slideInDown',
  },
  gf__slideInLeft: {
    '-webkit-animation-name': 'gf_slideInLeft',
    'animation-name': 'gf_slideInLeft',
  },
  gf__slideInRight: {
    '-webkit-animation-name': 'gf_slideInRight',
    'animation-name': 'gf_slideInRight',
  },
  gf__slideInUp: {
    '-webkit-animation-name': 'gf_slideInUp',
    'animation-name': 'gf_slideInUp',
  },
  gf__slideOutDown: {
    '-webkit-animation-name': 'gf_slideOutDown',
    'animation-name': 'gf_slideOutDown',
  },
  gf__slideOutLeft: {
    '-webkit-animation-name': 'gf_slideOutLeft',
    'animation-name': 'gf_slideOutLeft',
  },
  gf__slideOutRight: {
    '-webkit-animation-name': 'gf_slideOutRight',
    'animation-name': 'gf_slideOutRight',
  },
  gf__slideOutUp: {
    '-webkit-animation-name': 'gf_slideOutUp',
    'animation-name': 'gf_slideOutUp',
  },
};
